import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Api from "../../Api";
import { ListNotificationsMapping, NewNotificationMappingModalForm } from "../../component";

const NotificationsMapping = () => {
  interface NotificationMapping {
    categoryId: number;
    stateId: number;
    stateName: string;
    categoryName: string;
  }

  interface StateType {
    stateName: string, 
    stateId: number
  }

  interface CategoryType {
    categoryName: string, 
    categoryId: number
  }

  const initialState = {
    stateId: null,
    categoryId: null,
  };

  const [notificationMappings, setNotificationMappings] = useState<NotificationMapping[]>([
  ]);
  const [findOptions, setFindOptions] = useState(initialState);
  const [stateOptions, setStateOptions]=useState<StateType[]>([])
  const [categoryOptions, setCategoryOptions]=useState<CategoryType[]>([])
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [listCount, setListCount] = useState(0);
  const resetFindOptions = () => setFindOptions(initialState);
  const api = Api();

  const handleFindMapping = (findOptions: any) => setFindOptions(findOptions);
  const handleCreateMapping = (payload: {"categoryIds": number[], "stateIds": number[]}) => {
    api.notificationWorkflowMapping.createNotificationWorkflowMappings(payload).then((response: any) => {
      toast.success(response.message);
      getNotificationWorkflowMapping({...findOptions, pageIndex, pageSize});
    });
  };

  const fetchForDropdown = async () => {
    const stateResponse = await api.state.getStates();
    const categoryResponse = await api.category.getCategories();
    setStateOptions([...stateResponse.states])
    setCategoryOptions([...categoryResponse.categories])

  };

  const getNotificationWorkflowMapping = (findOptions: any) => {
    api.notificationWorkflowMapping.getNotificationWorkflowMappings(findOptions).then((response: any)=>{
      if(response){
        setListCount(response.notificationWorkflowMapListCount);
        setNotificationMappings(response.notificationWorkflowMapList)
          if(response.notificationWorkflowMapListPageIndex>1 && response.notificationWorkflowMapListPageSize === 0){
          setPageIndex(pageIndex-1)
        }
      }
    })
  };

  const handelDelete = (stateId: number, categoryId: number) => {
    api.notificationWorkflowMapping.deleteNotificationWorkflowMappings(stateId, categoryId).then((response: any)=>{
      if(response){
        toast.success(response.message);
        getNotificationWorkflowMapping({...findOptions, pageIndex, pageSize});
      }
    })
  };

  const onChangePageIndex = (pageNumber: number) =>
    setPageIndex(pageNumber - 1);
  const onChangePageSize = (pageSize: number) => setPageSize(pageSize);
  


  useEffect(() => {
    getNotificationWorkflowMapping({...findOptions, pageIndex, pageSize});
  }, [findOptions, pageIndex, pageSize]);

  useEffect(()=>{
    fetchForDropdown()
  },[]);

  return (
    <div className="w-100">
      <div className="float-end mx-2">
        <NewNotificationMappingModalForm
          onCreateNewMapping={handleCreateMapping}
          stateListForDropdown={stateOptions}
          categoryListForDropdown={categoryOptions}
        />
      </div>

      <ListNotificationsMapping
        notificationMapList={notificationMappings}
        resetFindOptions={resetFindOptions}
        findOptions={findOptions}
        stateListForDropdown={stateOptions}
        categoryListForDropdown={categoryOptions}
        handleFindMapping={handleFindMapping}
        handelDelete={(stateId: number, categoryId: number) =>
          handelDelete(stateId, categoryId)
        }
        totalItemCount={listCount}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onChangePageIndex={(pageNumber: number) =>
          onChangePageIndex(pageNumber)
        }
        onChangePageSize={onChangePageSize}
      />
    </div>
  );
};

export default NotificationsMapping;
